import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './NotificationModal.css';
import bgsmImg from '../../assets/BGSM.png';
import bannerImg from '../../assets/banner-shape.png';
import line1 from '../../assets/line1.svg';
import line2 from '../../assets/line2.svg';
import line3 from '../../assets/line3.svg';
import right from '../../assets/right.svg';
import error from '../../assets/error2.png';
import { ensureConfig, getConfig } from '@edx/frontend-platform';
import Cookies from 'js-cookie';

ensureConfig([
  'STUDIO_BASE_URL',
  'LMS_BASE_URL'
   
], 'NotificationModal component');


const NotificationModal = () => {
    const [notificationTitle, setNotificationTitle] = useState('');
    const [details, setDetails] = useState('');
    // const [link, setLink] = useState('');
    const [categoryType, setCategoryType] = useState('');
    const [program, setProgram] = useState(null);
    const [course, setCourse] = useState(null);
    const [audience, setAudience] = useState('');
    const [user, setUser] = useState(null);
    const [alluser, setAllUser] = useState(null);
    const [programOptions, setProgramOptions] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [showNotification, setShowNotification] = useState(false);
    const [errors, setErrors] = useState({});

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: 'white',
            borderColor: state.isFocused ? '#014F66' : '#ccc',
            boxShadow: state.isFocused ? '0 0 0 1px #014F66' : null,
            '&:hover': {
                borderColor: state.isFocused ? '##014F66' : '#999',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#014F66' : state.isFocused ? '#DEEBFF' : null,
            color: state.isSelected ? 'white' : 'black',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#014F66',
            borderRadius: '3px',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#F4C341',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#F4C341',
            ':hover': {
                backgroundColor: '#014F66',
                color: 'F4C341',
                cursor: 'pointer',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            overflowX: 'hidden'
        }),
    };

    const handleCategorySelection = (type) => {
        setCategoryType(type);
        setProgram(null);  // Reset program, course, and audience when a new category type is selected
        setCourse(null);
        setAudience('');
        setUser(null);
        if (type === 'alluser') {
        setAllUser(true);   // ✅ enable send-button for All User
        } else {
        setAllUser(null);   // ✅ reset in other cases
        }
        setErrors({});
    };

    const validateField = (name, value) => {
        let errorMsg = '';

        switch (name) {
            case 'notificationTitle':
                if (!value.trim()) errorMsg = 'Notification title is required';
                break;
            case 'details':
                const strippedDetails = value.replace(/<(.|\n)*?>/g, '').trim();
                if (!strippedDetails) {
                    errorMsg = 'Details are required';
                }
                break;
            // case 'link':
                // const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
                // if (!value.trim()) {
                    // errorMsg = 'Link is required';
                // } else if (!urlPattern.test(value)) {
                    // errorMsg = 'Please enter a valid URL';
                // }
                // break;
            default:
                break;
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMsg }));
        return !errorMsg;
    };

    const validateForm = () => {
        const isTitleValid = validateField('notificationTitle', notificationTitle);
        const isDetailsValid = validateField('details', details);
        // const isLinkValid = validateField('link', link);

        return isTitleValid && isDetailsValid;
    };
    
    const handleSendClick = async () => {
        if (validateForm()) {
  
            const plainTextDetails = stripHtml(details); 

            const notificationData = {
                type: 'manual',
                title: notificationTitle,
                content: plainTextDetails,
                recipients: audience || 'all_user',
                status: 'sent',
                category: categoryType || 'user_wise',
                timestamp: new Date().toISOString(),
                program: Array.isArray(program) ? program.map(p => ({ uuid: p.value, display_name: p.label })) : [],
                course: Array.isArray(course) ? course.map(c => c.value) : [],
                users: Array.isArray(user) ? user.map(u => u.label) : [],
                notify_all_users: alluser,
                ios_link: "",
                web_link: "",
                android_link: "",
            };

            try {
                const response = await fetch(`${getConfig().LMS_BASE_URL}/api/notification/create/`, {
                    method: 'POST',
                    headers: {
                        'X-CSRFTOKEN': Cookies.get('csrftoken'),    
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify(notificationData),
                    
                });

                if (response.ok) {
                    setShowNotification(true);
                } else {
                    const errorData = await response.json();
                    console.error('Error:', errorData);
                    setErrors({ apiError: 'Failed to send notification' });
                }
            } catch (error) {
                console.error('Error:', error);
                setErrors({ apiError: 'Failed to send notification' });
            }
        }
    };


    const handleFieldChange = (name, value) => {
        switch (name) {
            case 'notificationTitle':
                setNotificationTitle(value);
                validateField(name, value);
                break;
            case 'details':
                setDetails(value);
                validateField(name, value);
                break;
            // case 'link':
                // setLink(value);
                // validateField(name, value);
                // break;
            case 'program':
                setProgram(value);
                break;
            case 'course':
                setCourse(value);
                break;
            case 'audience':
                setAudience(value);
                break;
            case 'user':
                setUser(value);
                break;
            case 'alluser':
                setAllUser(value);
                break;
            default:
                break;
        }
        validateField(name, value);
    };


    const fetchProgramData = async () => {
        try {
            const response = await fetch(`${getConfig().STUDIO_BASE_URL}/api/notification/programs/`);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            const programs = data.programs.map(program => ({
                value: program.uuid,
                label: program.program_name,
                courses: program.courses.map(course => ({
                    value: course.course_key,
                    label: course.course_name,
                })),
            }));
            setProgramOptions(programs);
        } catch (error) {
            console.error('Error fetching programs:', error);
        }
    };

    const fetchCourseData = async () => {
        try {
            const response = await fetch(`${getConfig().STUDIO_BASE_URL}/api/notification/programs/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}), // Adjust the body if needed
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            const courses = data.courses.map(course => ({
                value: course.course_key,
                label: course.course_name,
            }));
            setCourseOptions(courses);
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    };

    const fetchUserData = async () => {
        try {
            const response = await fetch(`${getConfig().STUDIO_BASE_URL}/api/notification/allusers/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}), // Adjust the body if needed
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            const users = data.users.map(user => ({
                value: user.id,
                label: user.username,
            }));
            setUserOptions(users);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    
    useEffect(() => {
        if (categoryType === 'program_wise') {
            fetchProgramData();
        } else if (categoryType === 'course_wise') {
            fetchCourseData();
        } else if (categoryType === 'user_wise') {
            fetchUserData();
        }
         else if (categoryType === 'alluser') {}
    }, [categoryType]);
            

      const handleProgramChange = (field, selectedOptions) => {
        if (field === 'program') {
          setProgram(selectedOptions); // Set the selected program
          // Find the selected program's courses and set them to courseOptions
          const selectedProgram = selectedOptions[0]; // Assuming single program selection for simplicity
          if (selectedProgram) {
            const selectedCourses = programOptions.find(program => program.value === selectedProgram.value)?.courses || [];
            setCourseOptions(selectedCourses); // Update the course dropdown with the courses for the selected program
          } else {
            setCourseOptions([]); // Clear the courses if no program is selected
          }
        } else if (field === 'course') {
          setCourse(selectedOptions); // Set the selected courses
        }
      };    
      
      const stripHtml = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
      };

      const handleDetailsChange = (field, value) => {
        if (field === 'details') {
          setDetails(value);  // Store the HTML content while editing
        } else {
          setFormValues({ ...formValues, [field]: value });
        }
      };
      

    return (

        <div className={`${showNotification ? 'modal-overlay-1' : 'modal-overlay'}`}>
            <img src={bgsmImg} alt="" className='bgsm-img' />
            <img src={bannerImg} alt="" className='dot-img' />


            {showNotification ? (
                <div className="success-popup">
                    <div className="success-content">
                        {/* <button onClick={() => setShowNotification(false)} className="close-success">×</button> */}
                        <Link to="/notification-panel"><button className='close-success'>×</button></Link>

                        <div className="success-icon">
                            <div className='right'>
                                <img src={right} alt="" />
                            </div>
                            <div className="notification-msg">
                                <img src={line1} alt="" />
                                <img src={line2} alt="" />
                                <img src={line3} alt="" />
                            </div>
                        </div>
                        <div className="msg-content">
                            <p>Your notification has been sent successfully!</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="modal-content-1">
                    <div className="close-btn">
                        <Link to='/notification-panel'><button className="close-button">×</button></Link>
                    </div>
                    <div className="modal-header-1">
                        <div className="modal-heading">
                            <h2>Notification Panel</h2>
                        </div>
                    </div>
                    <div className="modal-body-1">
                        <div className="form-group">
                            <div className="field-wrapper">

                                <label>Notification Title:*</label>

                                <input
                                    type="text"
                                    value={notificationTitle}
                                    onChange={(e) => handleFieldChange('notificationTitle', e.target.value)}
                                    style={{
                                        border: errors.notificationTitle ? '1px solid red' : '1px solid #ccc',
                                        boxShadow: errors.notificationTitle ? '0 0 5px rgba(255,0,0,0.5)' : 'none',
                                    }}

                                />
                            </div>

                            <div className="error-wrapper">
                                {errors.notificationTitle && <span className="error"><img src={error} alt="" /><p>{errors.notificationTitle}</p></span>}
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="field-wrapper">
                                <label>Details:*</label>
                                <ReactQuill
                                    value={details}
                                    onChange={(value) => handleDetailsChange('details', value)}
                                    className={errors.details ? 'quill-1' : ''}
                                    modules={{
                                        toolbar: [
                                            [{ header: '1' }, { header: '2' }, { font: [] }],
                                            [{ size: [] }],
                                            [{ color: [] }, { background: [] }],
                                            ['bold', 'italic', 'underline', 'strike'],
                                            [{ list: 'ordered' }, { list: 'bullet' }],
                                            ['image'],
                                        ],
                                    }}
                                />
                            </div>


                            <div className="error-wrapper">
                                {errors.details && <span className="error"><img src={error} alt="" /><p>{errors.details}</p></span>}
                            </div>
                        </div>

                        {/*<div className="form-group">

                            <div className="field-wrapper">
                                <label>Link:*</label>
                                <input
                                    type="text"
                                    value={link}
                                    onChange={(e) => handleFieldChange('link', e.target.value)}
                                    style={{
                                        border: errors.link ? '1px solid red' : '1px solid #ccc',
                                        boxShadow: errors.link ? '0 0 5px rgba(255,0,0,0.5)' : 'none',
                                    }}
                                />
                            </div>


                            <div className="error-wrapper">
                                {errors.link && <span className="error"><img src={error} alt="" /><p>{errors.link}</p></span>}
                            </div>


                        </div>
                        */}
                        <div className="form-group">

                            <div className="field-wrapper">
                                <label>Category Type:*</label>
                                <div className="category-buttons">
                                    <button onClick={() => handleCategorySelection('program_wise')} className={categoryType === 'program_wise' ? 'active' : ''}>
                                        <i className="fa-regular fa-file-lines"></i> <span>Program Wise</span>
                                    </button>
                                    <button onClick={() => handleCategorySelection('course_wise')} className={categoryType === 'course_wise' ? 'active' : ''}>
                                        <i className="fa-solid fa-book"></i> <span>Course Wise</span>
                                    </button>
                                    <button onClick={() => handleCategorySelection('user_wise')} className={categoryType === 'user_wise' ? 'active' : ''}>
                                        <i className="fa-regular fa-user"></i> <span>User Wise</span>
                                    </button>
                                    <button onClick={() => handleCategorySelection('alluser')} className={categoryType === 'alluser' ? 'active' : ''}>
                                        <i className="fa-regular fa-all-userwise"></i> <span>All User</span>
                                    </button>
                                </div>

                            </div>




                            <div className="error-wrapper">
                                {errors.categoryType && <span className="error"><img src={error} alt="" /><p>{errors.categoryType}</p></span>}
                            </div>
                        </div>

                        <div className={`form-group ${categoryType === 'program_wise' ? '' : 'hidden'}`}>
                            {categoryType === 'program_wise' && (
                                <>
                                    <div className="field-wrapper">
                                        <label>Program List:</label>
                                        <Select
                                            value={program}
                                            onChange={(selectedOptions) => handleProgramChange('program', selectedOptions)}
                                            options={programOptions}
                                            isMulti
                                            styles={customStyles}
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            placeholder="Select Program"
                                        />
                                    </div>

                                    <div className="error-wrapper">
                                        {errors.program && <span className="error"><img src={error} alt="" /><p>{errors.program}</p></span>}
                                    </div>
                                </>
                            )}
                        </div>

                        <div className={`form-group ${program || categoryType === 'course_wise' ? '' : 'hidden'}`}>
                            {(program || categoryType === 'course_wise') && (
                                <>
                                    <div className="field-wrapper">
                                        <label>Course List:</label>
                                        <Select
                                            value={course}
                                            onChange={(selectedOptions) => setCourse(selectedOptions)}
                                            options={courseOptions}
                                            isMulti
                                            placeholder="Select Courses"
                                            styles={customStyles}
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                        />
                                    </div>

                                    <div className="error-wrapper">
                                        {errors.course && <span className="error"><img src={error} alt="" /><p>{errors.course}</p></span>}
                                    </div>
                                </>
                            )}
                        </div>


                        <div className={`form-group ${course && categoryType !== 'user_wise' ? '' : 'hidden'}`}>
                            {(course && categoryType !== 'user_wise') && (
                                <>
                                    <div className="field-wrapper">
                                        <label>Audience List:</label>
                                        <div className="audience-buttons">
                                            <button onClick={() => setAudience('student')} className={audience === 'student' ? 'active' : ''}>
                                                <i className="fa-regular fa-user"></i> <span>Student</span>
                                            </button>
                                            <button onClick={() => setAudience('teacher')} className={audience === 'teacher' ? 'active' : ''}>
                                                <i className="fa-solid fa-chalkboard-user"></i><span>Teacher</span>
                                            </button>
                                            <button onClick={() => setAudience('all_user')} className={audience === 'all' ? 'active' : ''}>
                                                <i className="fa-regular fa-user"></i><span>All User</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="error-wrapper">
                                        {errors.audience && <span className="error"><img src={error} alt="" /><p>{errors.audience}</p></span>}
                                    </div>

                                </>
                            )}
                        </div>

                        <div className={`form-group ${categoryType === 'user_wise' ? '' : 'hidden'}`}>
                            {categoryType === 'user_wise' && (
                                <>
                                    <div className="field-wrapper">
                                        <label>User List:</label>
                                        <Select
                                            value={user}
                                            onChange={(selectedOptions) => setUser(selectedOptions)}
                                            options={userOptions}
                                            isMulti
                                            placeholder="Select Users"
                                            styles={customStyles}
                                            menuPlacement='auto'
                                            menuPosition='fixed'
                                        />
                                    </div>
                                    
                                    <div className="error-wrapper">
                                        {errors.user && <span className="error"><img src={error} alt="" /><p>{errors.user}</p></span>}
                                    </div>

                                </>
                            )}
                        </div>

                        <div className="form-group">
                            <div className="field-wrapper">
                                {(audience || user || alluser) && (
                                    <button className="send-button" onClick={handleSendClick}>Send <i className="fa-regular fa-paper-plane"></i></button>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default NotificationModal;
